
import React, { useEffect, useState } from "react";
import { Card, Table, Spinner } from "react-bootstrap";
import Axios from "../../../services/AxiosInterceptor";

const VendorBookings = () => {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBookings = async () => {
      try {
        const Role = localStorage.getItem("role"); // Get User ID from localStorage
        if (!Role) {
          console.error("No User ID found in localStorage");
          return;
        }

        // Fetch all bookings (PENDING + CONFIRMED)
        const response = await Axios.post("api/get_booking_data", { role: Role, includePending: true });
        const reverse=response.data.data.reverse()
        setBookings(reverse);
      } catch (error) {
        console.error("Error fetching bookings:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBookings();
  }, []);

console.log("booking",bookings)

  const handleApprove = async (id) => {
    if (!window.confirm("Are you sure you want to approve this payment?")) return;
    try {
      const res = await Axios.put("api/booking/payment-status", { bookingId: id, status: 'CONFIRMED' });
      if (res.data.success) {
        alert("Booking Approved!");
        window.location.reload();
      }
    } catch (error) {
      console.error("Error approving:", error);
      alert("Failed to approve.");
    }
  };

  const handleReject = async (id) => {
    if (!window.confirm("Are you sure you want to REJECT this payment? Seats will be released.")) return;
    try {
      const res = await Axios.put("api/booking/payment-status", { bookingId: id, status: 'REJECTED' });
      if (res.data.success) {
        alert("Booking Rejected!");
        window.location.reload();
      }
    } catch (error) {
      console.error("Error rejecting:", error);
      alert("Failed to reject.");
    }
  };

  return (
      <div>
        <h3>📦Bookings</h3>
        {loading ? (
          <Spinner animation="border" />
        ) : bookings.length === 0 ? (
          <p>No bookings found.</p>
        ) : (
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th>Username</th>
                <th>Service Name</th>
                <th>Location</th>
                <th>Date</th>
                <th>Time</th>
                <th>Seats</th>
                <th>Amount</th>
                <th>Txn ID</th>
                <th>Mobile</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {bookings.map((booking, index) => (
                <tr key={index}>
                  <td>{booking.username || 'N/A'}</td>
                  <td>{booking.serviceName || 'N/A'}</td>
                  <td>{booking.location}</td>
                  <td>{booking.date}</td>
                  <td>{booking.time}</td>
                  <td>{booking.seatsBooked}</td>
                  <td>₹{booking.amountPaid}</td>
                  <td>{booking.transactionId}</td>
                  <td>{booking.mobile}</td>
                  <td>
                    <span className={`badge ${
                      booking.paymentStatus === "CONFIRMED" ? "bg-success" : 
                      booking.paymentStatus === "PENDING" ? "bg-warning text-dark" : "bg-danger"
                    }`}>
                      {booking.paymentStatus}
                    </span>
                  </td>
                  <td>
                    {booking.paymentStatus === "PENDING" && (
                      <div className="mb-2">
                        <button className="btn btn-sm btn-success me-2" onClick={() => handleApprove(booking._id)}>Approve</button>
                        <button className="btn btn-sm btn-danger" onClick={() => handleReject(booking._id)}>Reject</button>
                      </div>
                    )}
                    <button
                      className="btn btn-sm btn-primary"
                      onClick={() => window.location.href = `/View_Booking_Details/${booking._id}`}
                    >
                      View
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </div>
  );
};

export default VendorBookings;


